import { AuthContext } from "@/context/AuthContext";
import { useDeviceLayout } from "@/hooks/useDeviceLayout";
import { Role } from "@/javascript/user-objects";
import { Group, Modal, ModalProps, Text } from "@mantine/core";
import { IconKeyOff } from "@tabler/icons-react";
import React, { useContext } from "react";

interface ConductionModalProps extends Omit<ModalProps, "opened"> {
    roles?: Role[];
    children?: React.ReactNode;
    opened?: boolean;
}

const ConductionModal: React.FC<ConductionModalProps> = ({
    roles,
    children,
    opened = true,
    ...modalProps
}) => {
    const deviceLayout = useDeviceLayout();
    if (deviceLayout.isPhoneOrSmaller) {
        modalProps.size = "100%";
    }

    const auth = useContext(AuthContext);
    if (!auth) {
        throw new Error("Modals must be a child of AuthContext.");
    }

    const isAuthorized = (roles === undefined || auth.roleCheck(roles));
    if (!isAuthorized) {
        children = (
            <Group>
                <Text>Access Denied</Text>
                <IconKeyOff size={24} color="yellow" />
            </Group>
        );
    }

    return (
        <Modal
            centered
            opened={opened}
            {...modalProps}
            children={children}
            styles={{
                title: {
                    fontSize: 26,
                    fontVariant: "all-small-caps"
                }
            }}
            // Stop the key event from propagating to timeline where it is consumed as a hotkey
            onKeyDown={e => e.stopPropagation()}
            onKeyUp={e => e.stopPropagation()}
        />
    );
};

export default ConductionModal;
